import { Menu, Layout, Skeleton, Button } from "antd";
import { siderMenu, ActionsMenu, GuestActionsMenu } from "./Sidebar.config";
import { useState } from "react";
import { styled } from "styled-components";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../features/auth/contexts/auth.provider";
import { Authority } from "@dataone/lib";
import {
  RightOutlined,
  LeftOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { useAppLayout } from "@dataone/lib";
import { OneGateLogo_1Icon, OneGateLogo_2Icon } from "@dataone/icons";
import { ProfileTheme_1Icon } from "@dataone/icons";
import { ProfileTheme_2Icon } from "@dataone/icons";
import { ProfileTheme_3Icon } from "@dataone/icons";
import { ProfileTheme_4Icon } from "@dataone/icons";
import { ProfileTheme_5Icon } from "@dataone/icons";

const { Sider } = Layout;

interface SidebarProps {
  collapsed: boolean;
}

export const Siderbar = ({ collapsed }: SidebarProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { logout, user, isAuthenticated } = useAuth();

  const [selectedKey, setSelectedKey] = useState(
    location.pathname.split("/")?.[1]
  );

  const handleClickMenu = ({ key }: { key: string }) => {
    setSelectedKey(key);
    useAppLayout.setState({ isSmartSearchVisible: false });
    useAppLayout.setState({ isResponseVisible: false });
    navigate(`/${key}`);
  };

  const handleClickActionsMenu = ({ key }: { key: string }) => {
    switch (key) {
      case "logout":
        logout();
        break;
      case "support":
        navigate("/support");
        break;
    }
  };

  const changeCollapsed = () => {
    useAppLayout.setState({ collapsed: !collapsed });
  };

  interface ProfileIcons {
    [key: string]: JSX.Element;
  }

  const profileIcons: ProfileIcons = {
    "1": <ProfileTheme_1Icon />,
    "2": <ProfileTheme_2Icon />,
    "3": <ProfileTheme_3Icon />,
    "4": <ProfileTheme_4Icon />,
    "5": <ProfileTheme_5Icon />,
  };

  return (
    <StyledSidebar $selectedKey={location.pathname.split("/")?.[1]}>
      <Button
        className="btn-collapse"
        type="text"
        icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
        onClick={changeCollapsed}
      />
      <Sider
        width="230px"
        theme="light"
        trigger={null}
        collapsible
        collapsed={collapsed}
      >
        <div>
          <Link target="_blank" to="https://www.onegate.ai/" rel="noreferrer">
            <StyledLogoIcon collapsed={collapsed}>
              {collapsed ? <OneGateLogo_1Icon /> : <OneGateLogo_2Icon />}
            </StyledLogoIcon>
          </Link>
          {/* {isAuthenticated && ( */}
          <StyledProfile>
            {user?.avatar ? (
              <StyledProfileIcon
                collapsed={collapsed}
                // onClick={() => handleClickMenu({ key: "profile" })}
              >
                {profileIcons[(user?.avatar || 1) as keyof ProfileIcons]}
              </StyledProfileIcon>
            ) : (
              <Skeleton.Avatar
                {...(collapsed && { style: { visibility: "hidden" } })}
                active
                shape="circle"
              />
            )}

            <div className="profile-username">
              {!user ? (
                <StyledUserLoading>
                  <Skeleton.Input active block size="small" />
                  <Skeleton.Input active block size="small" />
                </StyledUserLoading>
              ) : (
                <>
                  <span>{user?.firstName + " " + user?.lastName}</span>
                  <p>{user?.email}</p>
                </>
              )}
            </div>
          </StyledProfile>
          {/* )} */}
          {user && (
            <Menu
              mode="inline"
              defaultSelectedKeys={[
                selectedKey === "" ? "dashboard" : selectedKey,
              ]}
              items={siderMenu[user?.groups[0]]}
              onClick={handleClickMenu}
            ></Menu>
          )}
        </div>
        <div className="upgrade-plan">
          {user?.groups[0] &&
            ((user?.groups[0] === Authority.OG_SUBSCRIBER &&
              user?.subscription?.type === "FREE") ||
              user?.groups[0] === Authority.OG_GUEST) && (
              <StyledUpgradePlan>
                {/* <img
                  alt="upgrade plan"
                  width={100}
                  src="/images/profile/upgrade.png"
                /> */}
                <p>
                  {user?.subscription?.type === "FREE"
                    ? "Upgrade for the complete experience"
                    : "Choose a subscription plan that suits your needs"}
                </p>
                <Button onClick={() => navigate("/subscription")}>
                  {user?.subscription?.type === "FREE"
                    ? "Upgrade now"
                    : "Subscribe now"}
                  <ArrowRightOutlined />
                </Button>
              </StyledUpgradePlan>
            )}
        </div>
        {isAuthenticated && (
          <Menu
            onClick={handleClickActionsMenu}
            mode="inline"
            items={
              user?.groups[0] === Authority.OG_GUEST
                ? GuestActionsMenu
                : ActionsMenu
            }
          ></Menu>
        )}
      </Sider>
    </StyledSidebar>
  );
};

const StyledSidebar = styled.div<{ $selectedKey: string }>`
  position: relative;

  .ant-layout-sider {
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
    &:not(.ant-layout-sider-collapsed) {
      padding: 25px 25px 20px 25px;
    }
    border-right: 3px solid #eee;
    &::-webkit-scrollbar {
      width: 0px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #8b8b8b;
      border-radius: 7px;
    }
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ant-menu {
    border: none !important;
  }
  .ant-menu-item:active,
  .ant-menu-item-selected {
    color: #000;
    background-color: #0000000f;
  }
  .ant-layout-sider-collapsed {
    padding-block: 25px 20px;
    .logo {
      margin-left: 22px;
    }
    .profile-picture {
      transform: scale(0.6);
      margin-bottom: 5px;
    }
    .profile-username,
    .upgrade-plan,
    .upgrade-plan ~ .ant-btn {
      visibility: hidden;
    }
    .ant-menu-item {
      height: 35px;
      padding: 0px 25px;
    }
  }

  .ant-menu-inline .ant-menu-item {
    height: 35px;
    padding-inline: 14px !important;
    width: calc(100% + 10px);
    margin-left: -5px;
  }

  .btn-collapse {
    position: absolute;
    z-index: 1001;
    right: -14px;
    // top: 73px;
    top: 56px;
    font-size: 16px;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    padding-block: 2px;
    &,
    &:hover {
      color: #fff !important;
      background-color: #4974f6 !important;
      z-index: 1;
    }
  }

  .ant-menu-title-content {
    font-size: 12px;
  }
  .upgrade-plan {
    background: #eff1fd;
    border-radius: 8px;
    p {
      margin-top: -25px;
    }
  }
`;
const StyledProfile = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-block: 70px 50px;
  .ant-skeleton-avatar {
    height: 85px !important;
    width: 85px !important;
  }
  .profile-username {
    > span {
      margin-top: 10px;
      font-size: 13px;
      display: block;
      font-weight: 600;
      text-align: center;
    }
    > p {
      font-size: 10px;
      margin: 0;
      text-align: center;
    }
  }
`;
const StyledUpgradePlan = styled.div`
  position: relative;
  border-radius: 10px;
  background: #eff1fd;
  padding-inline: 15px;
  text-align: center;
  font-size: 11px;
  padding-bottom: 25px;
  margin-block: 30px 20px;

  img {
    margin-top: -25px;
    width: 85px;
  }

  .ant-btn {
    position: absolute;
    bottom: -15px;
    left: 18px;
    width: 140px;
    height: 35px;
    color: #fff !important;
    background-color: #4974f6;
    font-weight: 600;
    font-size: 12px;

    &:hover {
      opacity: 0.8;
    }
  }
`;

const StyledUserLoading = styled.div`
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  > div:nth-child(1) span {
    height: 20px !important;
  }

  > div:nth-child(2) span {
    height: 17px !important;
  }
`;

const StyledLogoIcon = styled.div<{ collapsed: boolean }>`
  // font-size: 45px;
  font-size: ${(props) => (props.collapsed ? "35px" : "115px")};
  color: #000;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-top: ${(props) => (props.collapsed ? "" : "-35px")};
  margin-bottom: ${(props) => (props.collapsed ? "" : "-58px")};
`;

const StyledProfileIcon = styled.div<{ collapsed: boolean }>`
  // transform: scale(0.6);
  transform: ${(props) => (props.collapsed ? "scale(0.6)" : "")};
  margin-bottom: 5px;
  font-size: 85px;
  display: flex;
  border-radius: 50%;
  border: 4px solid #eee;
  // cursor: pointer;
  // &:hover {
  //   opacity: 0.8;
  // }
`;
